import { render, staticRenderFns } from "./UpcomingSessionsRoute.vue?vue&type=template&id=29f1e4a9&scoped=true"
import script from "./UpcomingSessionsRoute.vue?vue&type=script&lang=ts"
export * from "./UpcomingSessionsRoute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f1e4a9",
  null
  
)

export default component.exports